import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import ButtonWithConfirm from "./modal.confirm-dialog.component";
import { SupplierPicker } from "./supplier-picker.component";
import { Supplier } from "../types/api";

interface Props {
  open: boolean;
  productCount: number;
  onCancel: () => void;
  onUpdate: (supplier: Supplier) => void;
}

// Bulk supplier change for the ticked products on the product list.
// Composes the shared SupplierPicker with the standard confirmation button.
const UpdateSupplierModal = (props: Props) => {
  const [supplier, setSupplier] = useState<Supplier | null>(null);

  useEffect(() => {
    if (props.open) setSupplier(null);
  }, [props.open]);

  const n = props.productCount;
  const noun = `${n} product${n !== 1 ? "s" : ""}`;

  return (
    <Dialog open={props.open} onClose={props.onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Update supplier of {noun}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Choose the supplier to set on the selected {noun}.
        </DialogContentText>
        <Box sx={{ mt: 1 }}>
          <SupplierPicker
            value={supplier?.guid}
            supplierChanged={(_event, value) => setSupplier(value)}
            label="New supplier"
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
        <div style={{ flex: "1 0 0" }} />
        <ButtonWithConfirm
          variant="contained"
          color="primary"
          disabled={!supplier}
          okButtonLabel="Update"
          message={`Please confirm you wish to change the supplier of ${noun} to ${supplier?.name}. This operation cannot be undone!`}
          onOk={() => supplier && props.onUpdate(supplier)}
        >
          Update
        </ButtonWithConfirm>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateSupplierModal;
